export default {
  namespaced: true,

  state: () => ({
    validated: false
  }),

  actions: {
    setValidated({ commit }, validated) {
      commit('set', validated);
    }
  },

  mutations: {
    set(state, validated) {
      state.validated = validated;
    }
  }
};
